<main class="main">
    <div class="sql-editor">
        <div class="editor-header">
            <h2>SQL Query Runner</h2>
            <span class="badge" *ngIf="!allowUpdate">SELECT only</span>
        </div>

        <div class="editor-area">
            <textarea [(ngModel)]="query" placeholder="SELECT * FROM dbo.MyTable WHERE ..." spellcheck="false"
                (keydown.control.enter)="run()">
            </textarea>
            <div class="editor-hint">Ctrl+Enter to run</div>
        </div>

        <div class="actions">
            <button class="btn-primary" (click)="run()" [disabled]="loading || !query.trim()">
                {{ loading ? 'Running…' : '▶ Run Query' }}
            </button>

            <button class="btn-secondary" (click)="clear()" [disabled]="loading">
                Clear
            </button>

            <label class="wrap-toggle" style="margin-top: 10px;">
                <input type="checkbox" [(ngModel)]="wrapText" />
                Wrap text
            </label>

            <button class="btn-primary" style="margin-left:auto;" (click)="exportToExcel(query)">
                ↓ Export to Excel
            </button>
        </div>

        <!-- Error -->
        <div class="error-box" *ngIf="error">
            <strong>Error:</strong> {{ error }}
        </div>

        <!-- Results -->
        <div class="results" *ngIf="result">

            <!--
            <div class="page-size-bar">
                <label>Rows per page:</label>
                <button
                    *ngFor="let size of pageSizeOptions"
                    class="page-size-btn"
                    [class.active]="pageSize === size"
                    (click)="onPageSizeChange(size)">
                    {{ size }}
                </button>
            </div>
            -->

            <div class="result-block" *ngFor="let table of result.Tables; let i = index">

                <div class="result-meta">

                    <span>
                        Query {{ i + 1 }} —
                        Showing {{ getPaginatedRows(table, i).length }} of
                        {{ getFilteredRows(table).length }} rows

                        <span class="filtered-note" *ngIf="getFilteredRows(table).length !== table.RowCount">
                            (filtered from {{ table.RowCount }})
                        </span>
                    </span>

                    <div class="result-meta-actions">

                        <button class="btn-link" *ngIf="table.Rows.length > 0" (click)="clearFilters()">
                            Clear filters
                        </button>

                    </div>

                </div>

                <div class="col-12 table-responsive" *ngIf="table.Rows.length > 0; else noRows">

                    <table class="table table-bordered">

                        <thead>

                            <tr>
                                <th *ngFor="let col of table.Columns">
                                    {{ col }}
                                </th>
                            </tr>

                            <tr class="filter-row">

                                <th *ngFor="let col of table.Columns">

                                    <div class="filter-box">

                                        <input *ngIf="!isValueless(col)" type="text" class="filter-input"
                                            placeholder="Search" [value]="getFilter(col).value"
                                            (input)="onFilterValueChange(col, $any($event.target).value)" />

                                        <button type="button" class="filter-btn" (click)="toggleFilterMenu(col)">
                                              <i class="pi pi-filter"></i>
                                        </button>

                                        <div class="filter-menu" *ngIf="activeFilterColumn === col">

                                            <select class="filter-operator" [value]="getFilter(col).operator"
                                                (change)="onOperatorChange(col, $any($event.target).value)">

                                                <option *ngFor="let op of filterOperators" [value]="op.value">
                                                    {{ op.label }}
                                                </option>

                                            </select>

                                        </div>

                                    </div>

                                </th>

                            </tr>

                        </thead>
                        <tbody>

                            <ng-container *ngIf="getPaginatedRows(table, i).length > 0; else noMatchingRows">

                                <tr *ngFor="let row of getPaginatedRows(table, i); let rowIndex = index">

                                    <td *ngFor="let col of table.Columns" [class.wrap]="wrapText">

                                        <ng-container *ngIf="isXML(row[col]); else normalCell">

                                            <a href="javascript:void(0)" class="xml-link"
                                                (click)="openXMLModal(row[col], col)"
                                                title="Click to view XML in browser">
                                                <i class="fa fa-file-code-o"></i>
                                                View XML
                                            </a>

                                        </ng-container>

                                        <ng-template #normalCell>
                                            {{ getCellValue(row[col]) }}
                                        </ng-template>

                                    </td>

                                </tr>

                            </ng-container>

                            <ng-template #noMatchingRows>
                                <tr>
                                    <td [attr.colspan]="table.Columns.length" class="no-match">
                                        No rows match the current filters.
                                    </td>
                                </tr>
                            </ng-template>

                        </tbody>
                    </table>
                </div>

                <ng-template #noRows>
                    <p class="empty">
                        Query {{ i + 1 }} returned no rows.
                    </p>
                </ng-template>

                <!-- Bottom bar -->
                <div class="table-footer">

                    <!-- Left -->
                    <div class="rows-per-page">

                        <select [id]="'pageSize_' + i" [value]="pageSize"
                            (change)="onPageSizeChange(+$any($event.target).value)">

                            <option *ngFor="let size of pageSizeOptions" [value]="size">
                                {{ size }}
                            </option>

                        </select>

                        <label [for]="'pageSize_' + i">
                            Items per page
                        </label>

                    </div>

                    <!-- Right -->
                    <div class="paginator">

                        <span class="page-info">
                            Page {{ getCurrentPage(i) }} of {{ getTotalPages(table, i) }}
                        </span>

                        <button class="page-btn" title="First" [disabled]="getCurrentPage(i) === 1"
                            (click)="goToPage(i,1,getTotalPages(table,i))">
                            «
                        </button>

                        <button class="page-btn" title="Previous" [disabled]="getCurrentPage(i) === 1"
                            (click)="goToPage(i,getCurrentPage(i)-1,getTotalPages(table,i))">
                            ‹
                        </button>

                        <ng-container *ngFor="let page of getPageNumbers(table,i)">

                            <span class="ellipsis" *ngIf="page === -1">…</span>

                            <button *ngIf="page !== -1" class="page-btn" [class.active]="getCurrentPage(i) === page"
                                (click)="goToPage(i,page,getTotalPages(table,i))">
                                {{ page }}
                            </button>

                        </ng-container>

                        <button class="page-btn" title="Next" [disabled]="getCurrentPage(i) === getTotalPages(table,i)"
                            (click)="goToPage(i,getCurrentPage(i)+1,getTotalPages(table,i))">
                            ›
                        </button>

                        <button class="page-btn" title="Last" [disabled]="getCurrentPage(i) === getTotalPages(table,i)"
                            (click)="goToPage(i,getTotalPages(table,i),getTotalPages(table,i))">
                            »
                        </button>

                    </div>

                </div>

            </div> <!-- result-block -->

        </div> <!-- results -->

    </div> <!-- sql-editor -->

    <app-loader [showLoader]="showLoader"></app-loader>

</main>